import { render, staticRenderFns } from "./BaseModalDialog.vue?vue&type=template&id=0f9c730d&"
import script from "./BaseModalDialog.vue?vue&type=script&lang=js&"
export * from "./BaseModalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports